import { CHA_ADJUSTMENTS } from "../constants/abilityAdjustments";

export function calculateChaBonus(character) {

  let LookupKey = character.stats['myCha'].toString().replace(/[^0-9]/g, ''); // strip out non-numerical

  let CHA_bonus_string ="";
  try {
    const CHA_adj = CHA_ADJUSTMENTS[parseInt(LookupKey)]
      console.log('Cha adj: ',CHA_adj)

      let adjuster = CHA_adj['reaction_adj'];
      const bonus = adjuster === 0 ? "" :
        (adjuster < 0 ? `-${Math.abs(adjuster)}%` : `+${adjuster}%`);
      console.log('Cha Saving Throw: ', bonus);

      CHA_bonus_string = bonus
      
      return { str: CHA_bonus_string, dict: CHA_adj }
    
  } catch(error) {
    console.log('fail gracefully')
    console.log(error)
  }

}